import service from "./baseRequest.js";

export function getUserDepartmentDistricts() {
  return service.get("districts");
}
